import { render, staticRenderFns } from "./stock_order_temp1.vue?vue&type=template&id=7b20fd52"
import script from "./stock_order_temp1.vue?vue&type=script&lang=js"
export * from "./stock_order_temp1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports